import { DashboardFiltersUrlParamsService } from '.';
import { service } from '../../migration/downgraded-providers';
import { CreateAndPinInsightService } from './shared/services/create-and-pin-insight.service';

export function downgradeDashboards() {
    service('DashboardFiltersUrlParams', DashboardFiltersUrlParamsService);
    service('CreateAndPinInsight', CreateAndPinInsightService);
}
